import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type State = {
  deletableAuthor: {
    id: number;
    name: string;
  } | null;
  setDeletableAuthors: (
    author: {
      id: number;
      name: string;
    } | null,
  ) => void;
};

export const useAuthorsStore = create<State>()(
  subscribeWithSelector(
    immer((set) => ({
      deletableAuthor: null,
      setDeletableAuthors(author) {
        return set((state) => {
          state.deletableAuthor = author;
        });
      },
    })),
  ),
);
